import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  error() {
    const src = this.element.src
    const match = src.match(/\/icon-lg\/(.+)$/)

    if (match) {
      const domain = match[1]
      const parts = domain.split(".")
      // Try root domain if currently on a subdomain (e.g. updates.coveragebook.com -> coveragebook.com)
      if (parts.length > 2) {
        this.element.src = src.replace(`/icon-lg/${domain}`, `/icon-lg/${parts.slice(-2).join(".")}`)
        return
      }
    }

    this.element.style.display = "none"
  }
}
